import Carousel from '../../../../lib/client_side_plugins/carousel'

const { rapidReady } = require('../../../../lib/utils/rapid')

export default (() => {
  class SupplementalContent {
    constructor({ selector }) {
      this.elems = [...document.querySelectorAll(selector)]
      // we need to add this event listener no matter if the supplemental content module is there or not on the first article for mounting the js for any subsequent articles which may contain this module
      document.addEventListener('supplementalcontent:added', this._handleInstanceAdded.bind(this))
      if (!this.elems.length) {
        return
      }
      this.elems.forEach(elem => this.init(elem))
    }

    init(elem) {
      const carouselClass = 'm-sc__carousel'
      elem._carouselInstance = new Carousel(elem, this, {
        carouselClass,
        viewport: elem,
        showMoreSlides: true
      })
    }

    _handleInstanceAdded({ detail }) {
      const { elem } = detail
      if (elem && !this.elems.includes(elem)) {
        this.elems.push(elem)
        this.init(elem)
        this.refreshRapid(elem)
      }
    }

    refreshRapid(elem) {
      const id = elem?.firstChild?.id
      rapidReady(rapid => {
        if (!id) return
        if (rapid.isModuleTracked(id)) {
          rapid.refreshModule(id)
        } else {
          rapid.addModulesWithViewability([id])
        }
      })
    }
  }

  return SupplementalContent
})()
